export function truncate(str: string, n: number, useWordBoundary: boolean = true) {
  if (!str || str.length <= n) { return str; }
  var subString = str.substr(0, n-1);
  return (useWordBoundary 
     ? subString.substr(0, subString.lastIndexOf(' ')) 
     : subString) + "&hellip;";
}

export function toHHMM(min_num: number) {
  let hours = Math.floor(min_num / 60)
  let minutes = Math.floor(min_num - (hours * 60))

  let hour_str = String(hours)
  if (hours < 10)
    hour_str = "0" + hours

  let min_str = String(minutes)
  if (minutes < 10)
    min_str = "0" + minutes
    
  return `${hour_str}:${min_str}`
}

export function sanitizeTags(input) {
  if (input) {
    return input.replace(/&amp;/g, '&')
  } else {
    return input
  }
}